import { render, staticRenderFns } from "./PersonalInfoSummary.vue?vue&type=template&id=fb278cd4&scoped=true&"
import script from "./PersonalInfoSummary.vue?vue&type=script&lang=js&"
export * from "./PersonalInfoSummary.vue?vue&type=script&lang=js&"
import style0 from "./PersonalInfoSummary.vue?vue&type=style&index=0&id=fb278cd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb278cd4",
  null
  
)

export default component.exports